<template>
<div>
        
  <vueSeamlessScroll :data="listData" :class-option="optionHover" class="seamless-warp">
      <ul class="item">
          <li v-for="item in listData" :key="item">
              <span class="title" v-text="item.title"></span><span class="date" v-text="item.date"></span>
          </li>
      </ul>
  </vueSeamlessScroll>
    <div class="flex align-center padding-tb-xs justify-between padding-lr-xs" style="background: linear-gradient(to right, #f52563, #df3737)">
    <div>
      <div class="text-white text-bold " style="font-size: 30px;text-align: left;margin-top: -5px;"><span style="font-size: 20px;padding: 10px 0;" class=" text-white ">￥</span>{{info.groupBuyingPrice/100}}</div>
      <div class="flex">
        <div class="text-white " style="font-size: 13px;text-decoration:line-through;">￥5555</div>
        <div style="background-color: #fff; height: 13px;width: 2px;margin:3px 2px;"></div>
        <div class="text-white  " style="  font-size: 13px;">已抢：{{info.soldNum||0}} 件</div>
      </div>
      <!-- <div class="flex  align-center  justify-between  bg-white" style="margin-top: 10px;">
        <div class="text-black text-bold text-xl" style="font-size: 20px;"><div class="cuIcon-titles lg text-red" style="width: 5px !important;height: 15px;background: #e54d42;display: inline-block;margin-left: 6px;"></div>限时抢购</div>
        <div class="text- margin-lr-xs padding-xs round-sm text-bold" style=" font-size: 18px;margin-right: 10px;">已抢：{{info.soldNum||0}} 件</div>
      </div> -->
    </div>
    <div>
      <div style=" padding-bottom:0px; font-size: 22px;" class="text-white text-right text-bold padding-lr-xs"><img  style="width: 20px;height: 20px;display: inline-block;margin-right: 3px;" src="img/fireBuy.png"/>限时抢购</div>
      <div class="flex-row time-box j_c flex margin-top-xs " style="font-size: 13px;">
        <div style="width: 30px;">还剩</div>
        <div class="time-item">{{left_time_list[0]}}</div>天
        <div class="time-item">{{left_time_list[1]}}</div>时
        <div class="time-item">{{left_time_list[2]}}</div>分
        <div class="time-item">{{left_time_list[3]}}</div>秒
      </div>
      <!-- <div class="flex align-center padding-tb-xs justify-between padding-lr-xs bg-red">
        <div class="text-white text-bold " style="font-size: 25px;"><span style="font-size: 20px;padding-top: 20px;" class=" text-white ">￥</span>{{info.groupBuyingPrice/100}}</div>
        <div class="flex-row time-box j_c flex margin-right-xs">
          <div class="time-item">{{left_time_list[0]}}</div>天
          <div class="time-item">{{left_time_list[1]}}</div>时
          <div class="time-item">{{left_time_list[2]}}</div>分
          <div class="time-item">{{left_time_list[3]}}</div>秒
        </div>
      </div> -->
    </div>
  </div>
</div>
</template>
<style lang="scss" scoped>
  .seamless-warp {
      height: 209px;
      overflow: hidden;
  }
</style>
<script>
import vueSeamlessScroll from 'vue-seamless-scroll'

  export default {
    components: {
        vueSeamlessScroll
    },
      data () {
          return {
              listData: [{
                 'title': '无缝滚动第一行无缝滚动第一行',
                 'date': '2017-12-16'
               }, {
                  'title': '无缝滚动第二行无缝滚动第二行',
                  'date': '2017-12-16'
               }, {
                   'title': '无缝滚动第三行无缝滚动第三行',
                   'date': '2017-12-16'
               }, {
                   'title': '无缝滚动第四行无缝滚动第四行',
                   'date': '2017-12-16'
               }, {
                   'title': '无缝滚动第五行无缝滚动第五行',
                   'date': '2017-12-16'
               }, {
                   'title': '无缝滚动第六行无缝滚动第六行',
                   'date': '2017-12-16'
               }, {
                   'title': '无缝滚动第七行无缝滚动第七行',
                   'date': '2017-12-16'
               }, {
                   'title': '无缝滚动第八行无缝滚动第八行',
                   'date': '2017-12-16'
               }, {
                   'title': '无缝滚动第九行无缝滚动第九行',
                   'date': '2017-12-16'
               }]
              }
          },
    computed: {
        optionHover () {
            return {
                    hoverStop: false,
                    step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
                }
        }
    }
     }
</script>
